import { artefactRouteSegmentFromPersona } from './artefactSessionPath';
import { FALLBACK_COLOR } from './landingPageAnalytics';

/** Artefacts that already crossfaded GIF → coloured WebGL this page session (avoids double GIF flash). */
const landingColoredRevealDone = new Set();

export function markLandingBlobColoredRevealed(artefactName) {
  const key = String(artefactName || '').trim();
  if (key) landingColoredRevealDone.add(key);
}

export function hasLandingBlobColoredRevealed(artefactName) {
  return landingColoredRevealDone.has(String(artefactName || '').trim());
}

/** Neutral gradient for default landing blob GIFs (no ethical colors). */
export const DEFAULT_LANDING_BLOB_GRADIENT = {
  c1: FALLBACK_COLOR,
  c2: FALLBACK_COLOR,
  c3: FALLBACK_COLOR,
};

export function getLandingBlobRouteKey(artefactName, personas) {
  const route = artefactRouteSegmentFromPersona(artefactName, personas);
  if (route) return route;
  return String(artefactName || '').trim() || 'default';
}

export function landingBlobGifPublicUrl(routeKey) {
  const base = typeof process !== 'undefined' && process.env?.PUBLIC_URL ? process.env.PUBLIC_URL : '';
  const prefix = base.endsWith('/') ? base.slice(0, -1) : base;
  return `${prefix}/landing-blobs/${routeKey}.gif`;
}

export function probeImageUrl(url) {
  if (typeof Image === 'undefined' || !url) {
    return Promise.resolve(false);
  }
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}
